import React from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import NavigationBar from './NavigationBar'


function SignIn() {
    return (
        <React.Fragment>
            <NavigationBar />
            <Container className="mt-5">
                <h1>Sign In</h1>
                <Form>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control type="email" placeholder="" />
                        
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" placeholder="" />
                    </Form.Group>
                    <Form.Group controlId="formBasicCheckbox">
                        <Form.Check type="checkbox" label="Remember me" />
                    </Form.Group>
                    <Button className="mb-3" variant="primary" type="submit">
                        Sign In
                    </Button>
                </Form>
            </Container>
        </React.Fragment>
    )
}

export default SignIn
